import { ProjectLogoProps } from './types';
import { Avatar } from '@mui/material';
import Typography from '@mui/material/Typography';
import { SvgImage } from 'components/images/SvgImage';

export default function ProjectLogo({ projectLogoUrl, projectName, organisationLogoUrl }: ProjectLogoProps) {
  const representativeCharacter = projectName?.charAt(0) ?? '';
  const logoUrl = projectLogoUrl || organisationLogoUrl;

  return (
    <Avatar
      src={logoUrl}
      variant="rounded"
      sx={{
        mb: 2,
        height: 'auto',
        width: '100%',
        minHeight: 104, // 0.5 * (240 - 16*2) = 104
        maxHeight: 188, // 0.9 * (240 - 16*2) = 187.2
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        overflow: 'hidden',
        backgroundColor: logoUrl ? 'transparent' : (theme) => theme.palette.secondary,
        '& img, & svg': {
          objectFit: 'contain',
        },
      }}
    >
      {logoUrl?.includes('.svg') ? (
        <SvgImage logoUrl={logoUrl} />
      ) : (
        <Typography variant="h5">{representativeCharacter}</Typography>
      )}
    </Avatar>
  );
}
